import {CommunityTreesPlantedHeader} from '../../ParticipationColumns/CommunityEvents/CommunityTreesPlanted';
import {ProjectCommunityTreesPlantedHeader} from '../../ParticipationColumns/CommunityEvents/ProjectCommunityTreesPlanted';
import {CommunityPlantedDBHHeader} from '../../ParticipationColumns/CommunityEvents/CommunityPlantedDBH';
import {DAMTagHeader} from '../../ParticipationColumns/Shared/DAMTag';
import {DeleteParticipationHeader} from '../../ParticipationColumns/Shared/DeleteParticipation';
import {EverythingValidatedHeader} from '../../ParticipationColumns/Shared/EverythingValidated';
import {ProposalHeader} from '../../ParticipationColumns/Shared/ProposalColumn';
import {DemoProjectHeader} from '../../ParticipationColumns/Shared/DemoProjectColumn';
import {ExcludedHeader} from '../../ParticipationColumns/Shared/Excluded';
import {FundedYearHeader} from '../../ParticipationColumns/Shared/FundedYear';
import {HasHeroHeader} from '../../ParticipationColumns/Shared/HasHero';
import {HasTreeSpeciesHeader} from '../../ParticipationColumns/Shared/HasTreeSpecies';
import {ImageCountHeader} from '../../ParticipationColumns/Shared/ImageCount';
import {ImagesValidatedHeader} from '../../ParticipationColumns/Shared/ImagesValidated';
import {ImpactStoryCompletedHeader} from '../../ParticipationColumns/Shared/ImpactStoryCompleted';
import {ImpactStoryInProgressHeader} from '../../ParticipationColumns/Shared/ImpactStoryInProgress';
import {MapHeader} from '../../ParticipationColumns/Shared/Map';
import {ParticipationIdHeader} from '../../ParticipationColumns/Shared/ParticipationId';
import {PlantingPartnerHeader} from '../../ParticipationColumns/Shared/PlantingPartner';
import {ProjectIdHeader} from '../../ParticipationColumns/Shared/ProjectId';
import {ProjectLocationHeader} from '../../ParticipationColumns/Shared/ProjectLocation';
import {ProjectNameHeader} from '../../ParticipationColumns/Shared/ProjectName';
import {ProjectStatusHeader} from '../../ParticipationColumns/Shared/ProjectStatus';
import {ProjectTypeHeader} from '../../ParticipationColumns/Shared/ProjectTypeColumn';
import {ReasonForPlantingHeader} from '../../ParticipationColumns/Shared/ReasonForPlanting';
import {ShowOnDateHeader} from '../../ParticipationColumns/Shared/ShowOnDate';
import { ProjectYearsHeader } from '../../ParticipationColumns/Shared/ProjectYears';
import {VisibleToParticipantHeader} from '../../ParticipationColumns/Shared/VisibleToParticipant';

export function MembershipTreesHeader() {
    return (
        <tr>
            <DeleteParticipationHeader />
            <ExcludedHeader />
            <EverythingValidatedHeader />
            <ProposalHeader />
            <DemoProjectHeader />
            <VisibleToParticipantHeader />
            <ParticipationIdHeader />
            <FundedYearHeader />
            <CommunityTreesPlantedHeader />
            <ShowOnDateHeader />
            <ProjectIdHeader />
            <ProjectTypeHeader />
            <ProjectNameHeader />
            <ProjectStatusHeader />
            <ProjectLocationHeader />
            <MapHeader />
            <ProjectYearsHeader />
            <ReasonForPlantingHeader />
            <ImpactStoryInProgressHeader />
            <ImpactStoryCompletedHeader />
            <PlantingPartnerHeader />
            <ProjectCommunityTreesPlantedHeader />
            <CommunityPlantedDBHHeader />
            <HasTreeSpeciesHeader />
            <DAMTagHeader />
            <ImagesValidatedHeader />
            <ImageCountHeader />
            <HasHeroHeader />
        </tr>
    );
}
